// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Bj6-","label":"LabeledBox_label__3vuY2"};